// extracted by mini-css-extract-plugin
export var documentation = "_i0-1";
export var menu = "_i0-0";